export default "__VITE_ASSET__qgF5$Y8F__"